import PropTypes from 'prop-types';
import React from 'react';
import { Form, Input, Select } from 'antd';
import { withTranslation } from 'react-i18next';

import NumericInput from '../../../components/NumericInput/NumericInput';
import { bankCodes, accountTypes } from '../external-transaction-data';
import { isValidRut } from '../../../helpers/transaction-utils';
import money from '../../../helpers/money';


const ExternalTransaction = withTranslation()(({ getFieldDecorator, t, currency, balance }) => {
  const { Option } = Select;

  return (
    <Form layout="vertical">
      <Form.Item label={t('transaction.external.rut')}>
        {getFieldDecorator('ext_rut', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.rut'),
            },
            {
              validator: (options, value) => ((!value.length || isValidRut(value)) ? Promise.resolve() : Promise.reject(t('transaction.external.invalid.rut'))),
            },
          ],
        })(<Input name="ext_rut" />)}
      </Form.Item>

      <Form.Item label={t('transaction.external.name')}>
        {getFieldDecorator('ext_name', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.name'),
            },
          ],
        })(<Input name="ext_name" />)}
      </Form.Item>

      <Form.Item label={t('transaction.external.description')}>
        {getFieldDecorator('ext_desc', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.description'),
            },
          ],
        })(<Input name="ext_desc" />)}
      </Form.Item>

      <Form.Item label={t('transaction.external.bank_code')}>
        {getFieldDecorator('ext_bank_code', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.bank_code'),
            },
          ],
        })(
          <Select
            name="ext_bank_code"
            showSearch
            placeholder="Select..."
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {
              bankCodes.map(({ code, description }) => (<Option key={code} value={code}>{description}</Option>))
            }
          </Select>,
        )}
      </Form.Item>

      <Form.Item label={t('transaction.external.account_type')}>
        {getFieldDecorator('ext_account_type', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.account_type'),
            },
          ],
        })(
          <Select
            name="ext_account_number"
            showSearch
            placeholder="Select..."
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {
              accountTypes.map(({ code, description }) => (<Option key={code} value={code}>{description}</Option>))
            }
          </Select>,
        )}
      </Form.Item>

      <Form.Item label={t('transaction.external.account_number')}>
        {getFieldDecorator('ext_account_number', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.account_number'),
            },
            { min: 6, message: t('transaction.external.min.account_number') },
            {
              max: 22,
              message: t('transaction.external.max.account_number'),
            },
          ],
        })(<Input name="ext_account_number" />)}
      </Form.Item>

      <Form.Item label={t('transaction.external.amount')}>
        {getFieldDecorator('ext_amount', {
          rules: [
            {
              required: true,
              message: t('transaction.external.required.amount'),
            },
            { min: 1, message: t('transaction.external.min.amount') },
            {
              validator: (options, value, callback) => {
                const minAmountError = [t('transaction.external.min.amount')];
                const maxAmountError = [t('transaction.external.max.amount')];
                const notNumericAmountError = [t('transaction.external.invalid.numeric_amount')];
                let numericValue;
                try {
                  numericValue = money.toInt(`${value}`, currency, false);
                } catch (error) {
                  console.error('ERROR: money.toInt (ExternalTransaction\'s amount validator): ', error); // eslint-disable-line no-console
                }
                let errors;
                switch (true) {
                  case (Number.isNaN(numericValue) && !!value):
                    errors = notNumericAmountError;
                    break;
                  case (numericValue === 0):
                    errors = minAmountError;
                    break;
                  case (numericValue > balance):
                    errors = maxAmountError;
                    break;
                  default:
                    break;
                }
                callback(errors);
              },
            },
          ],
        })(<NumericInput showtooltip showprefix tooltiptitle={t('transaction.external.amount')} currency={currency} name="ext_amount" />)}
      </Form.Item>
    </Form>
  );
});

ExternalTransaction.propTypes = {
  balance: PropTypes.number,
  currency: PropTypes.string,
  getFieldDecorator: PropTypes.func,
  t: PropTypes.func,
};

export default ExternalTransaction;
